import { render, staticRenderFns } from "./EdsPublicKey.vue?vue&type=template&id=84434e06&"
import script from "./EdsPublicKey.vue?vue&type=script&lang=js&"
export * from "./EdsPublicKey.vue?vue&type=script&lang=js&"
import style0 from "./EdsPublicKey.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports